import { apiRequest } from './client';
import type { WeatherStationRepository } from '../../application/ports/WeatherStationRepository';
import type { StationAgro, StationRange, WeatherStationOverview } from '../../domain/WeatherStation';

export class HttpWeatherStationRepository implements WeatherStationRepository {
  getOverview(deviceId: string, range: StationRange) {
    // La zona horaria del navegador define dónde corta "hoy" la lluvia del día.
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    return apiRequest<{ station: WeatherStationOverview }>(
      `/devices/${deviceId}/station?range=${range}&tz=${encodeURIComponent(tz)}`
    );
  }

  getAgro(deviceId: string, since: string, baseTemp: number) {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    return apiRequest<{ agro: StationAgro }>(
      `/devices/${deviceId}/station/agro?since=${since}&base=${baseTemp}&tz=${encodeURIComponent(tz)}`
    );
  }
}
